import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

const BASE = (groupId, farmId) =>
  `/bovexo/${groupId}/farms/${farmId}/animals/handling/alerts`;

export function findAll({ groupId, farmId }) {
  return apiAnimals.get(BASE(groupId, farmId), getHeaders(false, null));
}

export function save({ groupId, farmId, id, body }) {
  if (!id) {
    return apiAnimals.post(
      BASE(groupId, farmId),
      body,
      getHeaders(false, null),
    );
  }
  return apiAnimals.put(
    `${BASE(groupId, farmId)}/${id}`,
    body,
    getHeaders(false, null),
  );
}

export function deleteAlert({ groupId, farmId, id }) {
  return apiAnimals.delete(
    `${BASE(groupId, farmId)}/${id}`,
    getHeaders(false, null),
  );
}

export function activate({ groupId, farmId, id }) {
  return apiAnimals.post(
    `${BASE(groupId, farmId)}/${id}/activate`,
    null,
    getHeaders(false, null),
  );
}
